import { Inject, Injectable, Optional } from '@angular/core';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { CURRENCY_PER_COUNTRY } from '~shared/constants/locale.enum';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  constructor(@Optional() @Inject(REQUEST) private webAppBuyerRequest?: any) {
  }

  getCurrency(): string {
    return CURRENCY_PER_COUNTRY[getCountryDomainCode(this.webAppBuyerRequest)];
  }
}
